import React, { useEffect, useState } from 'react';
import { Button, Card, Toast, CardBody, Nav, Modal, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/AccountInfo.css'; // Custom CSS for additional styling
import PerformaceCard from './PerformaceCard';
import InfoMenuCard from './InfoMenuCard';
import TopContentCarousel from './TopContentCarousel'
import CommentAnalysis from './CommentAnalysis'
import GrowthInterest from './GrowthInterest'
import TagAndMentions from './TagAndMentions'
import AudienceSection from './AudienceSection'
import SimilarProfiles from './SimilarProfiles'
import InstagramSvg from '../assets/icons/Instagram_24px.svg';
import TikTokSvg from '../assets/icons/Tiktok_24px.svg'
import TelegramSvg from '../assets/icons/Telegram_24px.svg'
import CakeSvg from '../assets/icons/cake-icon.svg';
import LanguageSvg from '../assets/icons/language-icon.svg';
import GenderSvg from '../assets/icons/couple-icon.svg';
import EmailSvg from '../assets/icons/Gmail_24px.svg';
import AddressSvg from '../assets/icons/address-location-icon.svg';
import RateSvg from '../assets/icons/dollar-icon.svg';
import CurrentlyLivingSvg from '../assets/icons/home-owner-icon.svg';
import NicheSvg from '../assets/icons/interesting-facts-icon.svg';
import PhoneSvg from '../assets/icons/Whatsapp_24px.svg';
import AccountTypeSvg from '../assets/icons/registration-icon.svg';
import EditSvg from '../assets/icons/Edit_24px.svg';
import SaveSvg from '../assets/icons/green-checkmark-line-icon.svg';
import DeleteSvg from '../assets/icons/trash-icon.svg';
import WhiteWhatsappSvg from '../assets/icons/Group 481396.svg'
import { getProfileDetails, updateInfluencerDetails, logUserActivity, deleteInfluencer } from '../services/api.js';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const profileImg = 'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-11.webp';
const AccountInfo = ({ accountInfo }) => {
    const [profileDetails, setProfileDetails] = useState(null);
    const [proformaceData, setPerformaceData] = useState({});
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const navigate = useNavigate();
    const [editedData, setEditedData] = useState({
        phone: accountInfo.phone,
        email: accountInfo.email,
        rate: accountInfo.rate,
        internalNotes: accountInfo.internalNotes || '',
        favorite: accountInfo.favorite,
        instagramUsername: accountInfo.instagramUsername,
        tikTokUsername: accountInfo.tikTokUsername
    });
    const [platformAccountType, setPlatformAccountType] = useState(() => {
        if (accountInfo.instagramUsername) {
            return 'Instagram';
        }
        if (accountInfo.tikTokUsername) {
            return 'TikTok';
        }
    });
    const [activeLink, setActiveLink] = useState((platformAccountType));
    const [showNotification, setShowNotification] = useState(false);
    const { username, userRole } = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log(platformAccountType);
                var response = await getProfileDetails(accountInfo.influencerId, platformAccountType);

                if (response.status === 404) {
                    setError("Profile not found. Please check the influencer ID.");
                } else {
                    setProfileDetails(response.data);
                    setPerformaceData({
                        followerCounts: response.data.followerCount,
                        engagementRate: response.data.engagementRate,
                        avgLikes: response.data.averageLikes,
                        avgComments: response.data.averageComments,
                        avgViews: response.data.averageViews,
                        avgReelViews: response.data.averageReelsViews,
                        sponsoredPostPerformance: response.data.sponsoredPostsPerformance,
                    })
                    setError(null); // Clear any previous errors 
                }
            } catch (error) {
                console.log(error);
                setError("An error occurred while fetching the profile details.");
            }
        }
        fetchData();
    }, [accountInfo, platformAccountType]);

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleDelete = async () => {
        try {
            const response = await deleteInfluencer(accountInfo.influencerId);
            if (response.status === 200) {
                await logUserActivity({
                    apiEndpoint: `Delete Influencer named ${accountInfo.creatorName}`,
                    username: username
                });
                setShowDeleteModal(false);
                navigate('/dashboard');
            } else {
                setError("Failed to delete influencer. Please try again.");
            }
        } catch (error) {
            console.error("Error deleting influencer:", error);
            setError("An error occurred while deleting the influencer.");
        }
    };

    const handleSave = async () => {
        const { IG_engagementRate, IG_followers, TT_engagementRate, TT_followers, ...rest } = accountInfo;

        const updatedFields = {};

        if (accountInfo.phone !== editedData.phone) updatedFields.phone = editedData.phone;
        if (accountInfo.email !== editedData.email) updatedFields.email = editedData.email;
        if (accountInfo.rate !== editedData.rate) updatedFields.rate = editedData.rate;
        if (accountInfo.internalNotes !== editedData.internalNotes) updatedFields.internalNotes = editedData.internalNotes;
        if (accountInfo.favorite !== editedData.favorite) updatedFields.favorite = editedData.favorite;
        if (accountInfo.instagramUsername !== editedData.instagramUsername) {
            updatedFields.isUsernameUpdated = true;
            updatedFields.instagramUsername = editedData.instagramUsername;
        }
        if (accountInfo.tikTokUsername !== editedData.tikTokUsername) {
            updatedFields.isUsernameUpdated = true;
            updatedFields.tikTokUsername = editedData.tikTokUsername;
        }

        // Check if there are any changes
        if (Object.keys(updatedFields).length > 0) {
            const updatedData = { ...rest, ...updatedFields };

            try {
                const response = await updateInfluencerDetails(updatedData);
                if (response.status === 200) {
                    setShowNotification(true);
                    setTimeout(() => {
                        setShowNotification(false);
                    }, 3000);

                    // Update accountInfo with the new values
                    Object.assign(accountInfo, updatedFields);

                    setIsEditing(false);
                    await logUserActivity({
                        apiEndpoint: `Update Influencer named ${accountInfo.creatorName}'s details`,
                        username: username
                    });
                } else {
                    setError("Failed to update details. Please try again.");
                }
            } catch (error) {
                console.error("Error updating influencer details:", error);
                setError("An error occurred while updating the profile details.");
            }
        } else {
            setIsEditing(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedData(prev => ({ ...prev, [name]: value }));
    };


    const handlePlatformLink = (platform) => {
        setPlatformAccountType(platform);
        setActiveLink(platform);
    };

    return (
        <div>
            <div className="border border-muted rounded-7 w-auto my-3 p-3">
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="info-header-title">Account Details</h3>
                        <div>
                            {
                                isEditing ?
                                    <div className='d-flex align-items-center save-cancel-btn-div'>
                                        <button className="cancel-btn" onClick={() => setIsEditing(false)}>
                                            <div className='w-auto d-flex'>
                                                Cancel
                                            </div>
                                        </button>
                                        <button className="save-btn" onClick={handleSave}>
                                            <div className='w-auto d-flex'>
                                                Save Changes
                                            </div>
                                        </button>
                                    </div> :
                                    <button className="edit-btn" onClick={handleEdit}>
                                        <div className='w-auto d-flex'>
                                            <img src={EditSvg} alt="Edit" className='' style={{ width: '24px', height: '24px' }} />
                                        </div>
                                    </button>
                            }
                        </div>
                    </div>
                    <div className="mt-4 d-flex flex-column align-items-center">
                        <div className="p-1 d-flex flex-wrap w-100" >
                            <img alt="avatar" loading="lazy" width="120" height="120" className="rounded-circle" src={profileDetails?.imageUrl ? profileDetails.imageUrl : profileImg} />
                            <div className='mx-2'>
                                <div className="d-flex align-items-center">
                                    <h2 className="creator-name">{accountInfo.creatorName}</h2>
                                    {/* {isEditing ? (
                                            <label htmlFor="favoriteToggle" onClick={()=>setEditedData(prev=>({...prev, favorite: !prev.favorite}))}>
                                                {editedData.favorite ? 
                                                    <span style={{color: 'red', cursor: 'pointer'}}>❤️</span> : 
                                                    <span style={{cursor: 'pointer'}}>🤍</span>
                                                }
                                            </label>
                                    ) : (
                                        <div className="ms-2">
                                            {accountInfo.favorite ? 
                                                <span style={{color: 'red'}}>❤️</span> : 
                                                <span>🤍</span>
                                            }
                                        </div>
                                    )} */}
                                </div>
                                <div>
                                    <small className="creator-description">{`${profileDetails?.introduction}`}</small>
                                </div>
                                <div className='d-flex align-items-center w-100 gap-4 flex-wrap my-3 creator-social-account'>
                                    {accountInfo.instagramUsername && (
                                        isEditing ? (
                                            <div className='d-flex align-items-center social-icon-input-width mx-2' >
                                                <img src={InstagramSvg} alt="Instagram" className='' width={24} height={24} />
                                                <input
                                                    type="text"
                                                    className="form-control inline-input"
                                                    name="instagramUsername"
                                                    value={editedData.instagramUsername}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        ) : (
                                            <small className="text-muted me-1">
                                                <a href={`https://instagram.com/${accountInfo.instagramUsername.replace('@', '')}`} target="_blank" className='d-flex align-items-center justify-content-center social-icon-boundary'>
                                                    <img src={InstagramSvg} alt="Instagram" className='' />
                                                </a>
                                            </small>
                                        )
                                    )}
                                    {accountInfo.tikTokUsername && (
                                        isEditing ? (
                                            <div className='d-flex align-items-center social-icon-input-width mx-2'>
                                                <img src={TikTokSvg} alt="Instagram" className='' width={24} height={24} />
                                                <input
                                                    type="text"
                                                    className="form-control inline-input"
                                                    name="tikTokUsername"
                                                    value={editedData.tikTokUsername}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        ) : (
                                            <small className="text-muted mx-1">
                                                <a href={`https://tiktok.com/${accountInfo.tikTokUsername.startsWith('@') ? accountInfo.tikTokUsername : `@${accountInfo.tikTokUsername}`}`} target="_blank" className='d-flex align-items-center justify-content-center social-icon-boundary'>
                                                    <img src={TikTokSvg} alt="TikTok" className='' />
                                                </a>
                                            </small>
                                        )
                                    )}
                                    {accountInfo.telegramUsername && (
                                        <small className="text-muted mx-1">
                                            <a href={`https://t.me/${accountInfo.telegramUsername.replace('@', '')}`} target="_blank" rel="noopener noreferrer" className='d-flex align-items-center justify-content-center social-icon-boundary'>
                                                <img src={TelegramSvg} alt="Telegram" className='' />
                                            </a>
                                        </small>
                                    )}
                                    {accountInfo.email && (
                                        isEditing ? (
                                            <div className="d-flex align-items-center social-icon-input-width mx-2">
                                                <img src={EmailSvg} alt="Email" className='' width={24} height={24} />
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="email"
                                                    value={editedData.email}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        ) : (
                                            <small className="text-muted mx-1">
                                                <a href={`mailto:${accountInfo.email}`} target="_blank" rel="noopener noreferrer" className='d-flex justify-content-center align-items-center social-icon-boundary'>
                                                    <img src={EmailSvg} alt="Email" className='' />
                                                </a>
                                            </small>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='d-flex flex-wrap w-100 gap-4 py-2 h-100'>
                            <div className='content-detail-width user-content-details'>
                                <Row className="user-content">
                                    {accountInfo.age > 0 && (
                                        <Col md={4} className="d-flex align-items-center">
                                            <div className="me-2 content-icon mb-3">
                                                <img src="Frame 3015261.png" alt="Instagram" />
                                            </div>
                                            <div>
                                                <small>Creator's age:</small>
                                                <p>{accountInfo.age} years old</p>
                                            </div>
                                        </Col>
                                    )}
                                    {accountInfo.gender && (
                                        <Col md={4} className="d-flex align-items-center">
                                            <div className="me-2 content-icon mb-3">
                                                <img src="Gender.png" alt="Instagram" className='mx-1' />
                                            </div>
                                            <div>
                                                <small>Gender:</small>
                                                <p>{accountInfo.gender}</p>
                                            </div>
                                        </Col>
                                    )}
                                    {accountInfo.languages && (
                                        <Col md={4} className="d-flex align-items-center">
                                            <div className="me-2 content-icon mb-3">
                                                <img src="Language.png" alt="Instagram" className='mx-1' />
                                            </div>
                                            <div>
                                                <small>Language spoken:</small>
                                                <p>{accountInfo.languages}</p>
                                            </div>
                                        </Col>
                                    )}
                                </Row>
                                <Row className="user-content">
                                    {profileDetails?.platformAccountType && (
                                        <Col md={4} className="d-flex align-items-center">
                                            <div className="me-2 content-icon mb-3">
                                                <img src="Account.png" alt="Instagram" className='mx-1' />
                                            </div>
                                            <div>
                                                <small>Account type:</small>
                                                <p className='text-lowercase'>{profileDetails.platformAccountType}</p>
                                            </div>
                                        </Col>
                                    )}
                                    {accountInfo.rate && (
                                        <Col md={4} className="d-flex align-items-center creator-social-account">
                                            <div>
                                                {isEditing ? (
                                                    <div className='d-flex align-items-center social-icon-input-width w-100'>
                                                        <img src="Rate.png" alt="Instagram" className='' width={24} height={24} />
                                                        <input type="text" name="rate" className="form-control bg-transparent p-0" value={editedData.rate} onChange={handleChange} />
                                                    </div>
                                                ) : (
                                                    <div className='d-flex align-items-center'>
                                                        <img src="Rate.png" alt="Instagram" className='mx-1' />
                                                        <div><small>Rate:</small>
                                                            <p>{accountInfo.rate}</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    )}
                                    {accountInfo.niche && (
                                        <Col md={4} className="d-flex align-items-center">
                                            <div className="me-2 content-icon mb-3">
                                                <img src="Niche.png" alt="Instagram" className='mx-1' />
                                            </div>
                                            <div>
                                                <small>Niche</small>
                                                <p>{accountInfo.niche}</p>
                                            </div>
                                        </Col>
                                    )}
                                </Row>
                                <Row className="user-content">
                                    {accountInfo.homeAddress && (
                                        <Col md={4} className="d-flex align-items-center">
                                            <div className="me-2 content-icon mb-3">
                                                <img src="Address.png" alt="Instagram" className='mx-1' />
                                            </div>
                                            <div>
                                                <small>Address</small>
                                                <p>{accountInfo.homeAddress}</p>
                                            </div>
                                        </Col>
                                    )}
                                    {accountInfo.currentlyLiving && (
                                        <Col md={4} className="d-flex align-items-center">
                                            <div className="me-2 content-icon mb-3">
                                                <img src="Living.png" alt="Instagram" className='mx-1' />
                                            </div>
                                            <div>
                                                <small>Currently living in</small>
                                                <p>{accountInfo.currentlyLiving}</p>
                                            </div>
                                        </Col>
                                    )}
                                    {(accountInfo.phone || isEditing) && (
                                        <Col md={4} className="d-flex align-items-center creator-social-account">
                                            <div>

                                                {isEditing ? (
                                                    <div className='d-flex align-items-center social-icon-input-width w-100'>
                                                        <img src={PhoneSvg} alt="Instagram" />
                                                        <input type="text" className="form-control bg-transparent p-0" name="phone" placeholder="Phone number" value={editedData.phone} onChange={handleChange} />
                                                    </div>
                                                ) : (
                                                    <div className='whats-app-btn'>
                                                        <img src={WhiteWhatsappSvg} alt="Instagram" className='mx-1' style={{ width: '24px', height: '24px' }} />
                                                        <a href={`https://web.whatsapp.com/send?phone=${accountInfo.phone}`} target="_blank" rel="noopener noreferrer">{accountInfo.phone}</a>
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    )}
                                </Row>
                            </div>
                            <Row className="d-flex flex-wrap justify-content-start internal-notes-width creator-social-account">
                                {(isEditing || accountInfo.internalNotes) && (
                                    <div className={isEditing ? '' : 'internal-notes py-3'}>
                                        <small>Notes</small>
                                        {isEditing ? (
                                            <div className='social-icon-input-width w-100'><textarea type="text" className="form-control p-0" name="internalNotes" placeholder="Internal Notes" value={editedData.internalNotes} onChange={handleChange} /></div>
                                        ) : (
                                            <p>{accountInfo.internalNotes}</p>
                                        )}
                                    </div>
                                )}
                            </Row>
                        </div>
                    </div>
                </div>
            </div>

            {profileDetails && (

                <>
                    <InfoMenuCard />
                    <PerformaceCard performanceData={proformaceData} handlePlatformLink={handlePlatformLink} accountInfo={accountInfo} activeLink={activeLink} />
                    <TopContentCarousel influencerId={accountInfo.influencerId} profileImg={profileDetails?.imageUrl} platformAccountType={platformAccountType} isVerified={profileDetails?.isVerified} creatorName={accountInfo.creatorName}/>
                        <GrowthInterest influencerId={accountInfo.influencerId} platformAccountType={platformAccountType} />
                        <TagAndMentions influencerId={accountInfo.influencerId} platformAccountType={platformAccountType} />
                        <AudienceSection influencerId={accountInfo.influencerId} platformAccountType={platformAccountType} />
                </>
            )}
            <Toast show={showNotification} onClose={() => setShowNotification(false)} style={{ position: 'absolute', top: 0, right: 0, zIndex: 2000, backgroundColor: 'green' }}>
                <Toast.Body className='text-white'>Details updated successfully.</Toast.Body>
            </Toast>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete {accountInfo.creatorName}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AccountInfo;
